// extracted by mini-css-extract-plugin
module.exports = {"item":"CircleIcon_item___CISv","yellow":"CircleIcon_yellow__FKKIN","purple":"CircleIcon_purple__RM_xL","pink":"CircleIcon_pink__j0LZL","dark":"CircleIcon_dark__8Rp4G"};